/**
 * Shared appointment-management predicate (#2232).
 *
 * Every appointment-backed sheet must apply the SAME ownership invariant the
 * canonical AppointmentDetailSheet enforces: mutations are offered only for
 * patient-owned appointments that belong to the current patient and carry a
 * real appointment id. Adapters that drop ownership metadata make the
 * decision impossible — they must preserve `ownership`, `ownerId`, and the
 * canonical appointment id. The backend remains the authoritative
 * enforcement layer; this is presentation gating.
 *
 * Unlike medication ownership (which fails open for legacy rows), this
 * predicate FAILS CLOSED: an appointment without ownership metadata came
 * through an adapter that discarded it, and destructive actions must not be
 * offered on unknown ownership.
 */
export function canManageAppointment(
  appointment:
    | {
        ownership?: string | null;
        ownerId?: string | null;
        appointmentId?: string | null;
      }
    | null
    | undefined,
  patientId: string | null | undefined,
): boolean {
  if (!appointment || !patientId) return false;
  return (
    appointment.ownership === "patient" &&
    appointment.ownerId === patientId &&
    Boolean(appointment.appointmentId)
  );
}
